import { createFileRoute } from "@tanstack/react-router";
import { PlaceholderPanel } from "@/components/admin/PlaceholderPanel";

export const Route = createFileRoute("/_authenticated/admin/content")({
  component: () => (
    <PlaceholderPanel
      title="Pages & Sections (CMS)"
      description="Block-based editor for Home, About, Industry Association, Contact and custom landing pages."
      features={[
        "Drag-and-drop section blocks (hero, slideshow, stats, quote, CTA)",
        "Per-template content overrides",
        "Draft / Scheduled / Published states with audit trail",
        "Inline rich-text + image uploads",
        "SEO meta, OpenGraph, and canonical URL editor",
      ]}
    />
  ),
});
